import { effectiveWorkspaceRole } from "@common/helpers/effectiveWorkspaceRole";
import { useActiveWorkspace } from "@hooks/useActiveWorkspace";
import { useActiveWorkspaceAssigment } from "./useActiveWorkspaceAssignment";

export function useActiveWorkspaceRole() {
    const activeWorkspace = useActiveWorkspace();
    const activeWorkspaceAssignment = useActiveWorkspaceAssigment();

    // Read-only plan overlays every stored role to View-only (D11/D13), the
    // same rule the backend applies, so the two enforcement surfaces agree.
    return effectiveWorkspaceRole({
        storedRole: activeWorkspaceAssignment?.role ?? null,
        plan: activeWorkspace?.plan ?? null,
    });
}
